import { makeStyles } from '@mui/styles';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const usePropertyEditPageStyles = makeStyles({
  tabs: {
    position: 'sticky',
    top: '60px',
    zIndex: '1000',
    [breakpointsFunc.breakpoints.down('md')]: {
      padding: '0'
    }
  }
});
export default usePropertyEditPageStyles;